import React from 'react';
import DefaultButton from '../../../global/default-button/default-button';
import { LinkTargetValue } from '../../../../constants/common.constants';
import OpenInNewTabIcon from '../../../../images/svg/open-in-new-tab';

type OpenLinkInNewTabButtonProps = {
    link: string;
};

export const OpenLinkInNewTabButton: React.FC<OpenLinkInNewTabButtonProps> = ({ link }) => {
    const openLinkInNewTab = (): void => {
        window.open(link, LinkTargetValue.BLANK);
    };

    return (
        <DefaultButton
            text={
                <>
                    {link}
                    <span className='icon m-left-5px'>
                        <OpenInNewTabIcon />
                    </span>
                </>
            }
            onClick={openLinkInNewTab}
            modifier='slim'
        />
    );
};
